import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';
import { DataAutomation } from '.';
import { CollapsibleRowComp } from './CollapsibleRowComp';
import { MainTableRowStyle, RowCompTableCellStyle } from './styled';
type Props<P> = {
  row: P,
  hiddenColsOnMobile?: number[],
  isOneLevel: boolean,
  isThreeLevel: boolean,
  dataAutomation?: DataAutomation,
  noColsDivider: boolean,
  isFooterRow?: boolean,
  innerFooterRowIndexes?: number[];
  sxSmall?: boolean
};

export const RowComp = <P extends { [key: string]: any }>({
  row,
  hiddenColsOnMobile = [],
  isOneLevel,
  isThreeLevel,
  dataAutomation,
  noColsDivider,
  isFooterRow,
  innerFooterRowIndexes,
  sxSmall
}: Props<P>) => {
  const [open, setOpen] = React.useState(false);
  const isCollapsible = !isThreeLevel && Object.values(row).find(val => Array.isArray(val) && val.length);
  const collapsibleKeys = Object.keys(row).filter((key) => Array.isArray(row[key]));
  const oneLevelClassName = isOneLevel ? 'oneLevel' : '';
  const noPointerClassName = isOneLevel || isThreeLevel ? 'noPointer' : '';
  const noDividerClassName = noColsDivider ? 'noDivider' : '';
  const footerRowClassName = isFooterRow ? 'footerRow' : '';

  const getClassName = (i: number): string => {
    const collapsible = !i && isCollapsible ? 'collapsible' : '';
    const hiddenIndex = isThreeLevel ? i - 1 : i;
    const hidden = hiddenColsOnMobile.includes(hiddenIndex) ? 'hiddenOnMobile' : '';
    const threeLevel = isThreeLevel ? 'threeLevel' : ''
    return `${collapsible} ${hidden} ${threeLevel}`;
  }

  const handleClick = () => {
    if (!isThreeLevel) {
      setOpen(!open);
    }
  }

  const rowElement = (
    <TableRow
      className={`${oneLevelClassName} ${noPointerClassName} ${noDividerClassName} ${footerRowClassName} ${dataAutomation?.rows}`}
      sx={MainTableRowStyle}
      onClick={handleClick}
      data-automation={dataAutomation?.rows ?? "table-row"}
    >
      {Object.values(row).map((val, i) => !Array.isArray(val) && (
        <TableCell
          sx={RowCompTableCellStyle(sxSmall ? 0 : Math.min(val?.length * 2, 20))}
          className={getClassName(i)}
          key={i}
        >
          {!i && isCollapsible && (
            <Typography>
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </Typography>
          )}
          <Typography
            component={'div'}
            sx={{ ...isThreeLevel && { fontWeight: '600' } }}
          >
            {val}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  );

  return (
    <>
      {isThreeLevel ? <TableHead>{rowElement}</TableHead> : rowElement}
      {collapsibleKeys.map((key, i) => {
        const props = {
          dataAutomation,
          hiddenColsOnMobile,
          key: i,
          row: row[key],
          open: isThreeLevel ? true : open,
          align: isThreeLevel ? 'left' : undefined,
          innerFooterRowIndexes,
        };

        return <CollapsibleRowComp {...props} />
      })}
    </>
  );
}